var cookieGet = require('../functions/cookieGet');


function init() {
    // console.log('ghdBrandPromo');
    // ====================
    // Collect Variables
    // ====================

    var msg,
        getStartedURL,
        cta_videoCoverCTA_Title,
        cta_videoCoverCTA_MSG,
        page = window.location.pathname,
        cta_videoCoverLinks = $('#ghdVideoPlayer .video-cover ul'),
        cta_banner = $('.video-course-banner'),
        user = cookieGet.init('ghd_user'),
        brand = cookieGet.init('ghd_brand');

    // If marketing URL
    if ( user && brand && page.includes('/how-to-launch-giving/') ) {
        brand = brand.toLowerCase();

        $('#body').addClass('ghd-brand-' + brand );
        
        // Define the brand
        if ( user === 'lead' ) {
            if ( brand == 'easytithe' ) {
                cta_videoCoverCTA_Title = 'Sign Up Now';
                cta_videoCoverCTA_MSG = 'Sign Up with easyTithe';
                getStartedURL = 'https://www.easytithe.com/signup/?utm_source=givinghelpdesk';
                msg = '<h2><strong>Need a better giving platform?</strong> <br>Sign up for easyTithe—free for 30-days!</h2>'
                    + '<a href="' + getStartedURL + '" title="Sign Up with easyTithe Now" target="_blank">Sign Up Now</a>';


            } else if ( brand == 'kindrid' ) {
                cta_videoCoverCTA_Title = 'Join Now';
                cta_videoCoverCTA_MSG = 'Join Kindrid Now';
                getStartedURL = 'https://kindrid.com/join/?utm_source=givinghelpdesk';
                msg = '<h2><strong>Want a better online giving system?</strong> <br>Join Kindrid—your first 30-days are free</h2>'
                    + '<a href="' + getStartedURL + '" title="Join Kindrid Now" target="_blank">Join Now</a>';

            }
        }
 
    // How to Launch Giving banner
    } else {
        msg = '<h2><strong>Ready for some more?</strong> <br>Check out How to Launch Giving</h2>'
            + '<a href="/video-courses/how-to-launch-giving/" title="Watch, How to Launch Giving">Get Started!</a>';
    }


    // ====================
    // Build
    // ====================
    
    // Build Video Cover CTA
    if ( user === 'lead' && page.includes('/how-to-launch-giving/') && cta_videoCoverLinks ) {
        cta_videoCoverLinks.append(''
            + ' <li class="full sign-up">'
                + '<a href="' + getStartedURL + '" title="' + cta_videoCoverCTA_Title + '" class="join">' 
                    + cta_videoCoverCTA_MSG 
                + '</a>'
            + '</li>'
        );
    }

    // Build Banner
    if ( cta_banner && msg ) {
        // Add content
        cta_banner.append('<div class="msg">' + msg + '</div>');
        // Activate 
        $('#body').addClass('ghd-video-course-banner');
    }
}
module.exports = { init };